import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/lib/useQuery/queryKeys";
import { editSurveyInSurveyBank, EditSurveyInSurveyBankProps } from ".";

export function useEditSurveyInSurveyBank(){
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: queryKeys.survey_bank._def,
        mutationFn: editSurveyInSurveyBank,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.survey_bank._def, exact: false });
        }
    });
}
